import { Category, MultiLayoutDetails } from '@/types/pages/storeManagement/device';
import {
    ASSOCIATE_PAIRING_MODE,
    AssociateModeRelations,
    IdentifierInfo,
    ImageInfo,
    ShelfInfo,
} from '@/types/pages/storeManagement/device/associate';

export type MultiAssociationFlowContext = {
    mac: string;
    productBarcodes: string[];
    relations?: AssociateModeRelations;
};

export type MultiAssociationViewState = {
    styleList: Category[];
    selectedStyle: number | null;
    capacity: number;
    productValues: string[];
    multiLayoutInfo: MultiLayoutDetails;
    multiDefaultCheck: boolean;
    defaultLayoutId: number | null;
    selectedPairingMode: ASSOCIATE_PAIRING_MODE;
    showImageMode: boolean;
    planogramConfig: { enable: boolean; noOption: boolean; autoSelect: boolean };
    campaignEnable: boolean;

    layoutDialogOpen: boolean;
    planogramDialogOpen: boolean;
    imageDialogOpen: boolean;
    previewOpen: boolean;

    shelfInfo: ShelfInfo;
    imageInfo: ImageInfo;

    isProductInputEnabled: boolean;
    identifierInfo: IdentifierInfo | null;
    pendingAssociationContext: MultiAssociationFlowContext | null;
};

export const multiAssociationInitialShelfInfo: ShelfInfo = {
    openFeature: false,
    shouldOpenDialog: false,
    options: [],
    relations: {},
};

export const multiAssociationInitialImageInfo: ImageInfo = {
    openFeature: false,
    options: [],
    relations: {},
};

export const defaultState: MultiAssociationViewState = {
    styleList: [],
    selectedStyle: null,
    capacity: 1,
    productValues: [''],
    multiLayoutInfo: {},
    multiDefaultCheck: true,
    defaultLayoutId: null,
    selectedPairingMode: ASSOCIATE_PAIRING_MODE.NORMAL,
    showImageMode: false,
    planogramConfig: { enable: false, noOption: false, autoSelect: false },
    campaignEnable: false,

    layoutDialogOpen: false,
    planogramDialogOpen: false,
    imageDialogOpen: false,
    previewOpen: false,

    shelfInfo: multiAssociationInitialShelfInfo,
    imageInfo: multiAssociationInitialImageInfo,

    isProductInputEnabled: false,
    identifierInfo: null,
    pendingAssociationContext: null,
};

type MultiAssociationViewAction =
    | { type: 'RESET_ALL' }
    | { type: 'PATCH'; payload: Partial<MultiAssociationViewState> };

export const reducer = (
    state: MultiAssociationViewState,
    action: MultiAssociationViewAction,
): MultiAssociationViewState => {
    switch (action.type) {
        case 'RESET_ALL':
            return defaultState;
        case 'PATCH':
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
